<template>
  <div
    v-if="giftProp && (choosableGiftProp || giftOptionsProp)"
    class="choosable-gift__container"
  >
    <choosable-gift-btn
      :line-item-id="lineItemIdProp"
      :current-variant-id="currentVariantIdProp"
      :new-choosable-gift="giftOptionsProp"
      @newVariant="newVariant"
    />
  </div>
  <div v-else-if="showActionsProp" class="line-item-actions">
    <selectable-line-item-quantity
      v-if="showSelectQuantityProp && !kitProp"
      :stock="promotionEventStockProp"
      :selected="lineItemQuantityProp"
      @change="changeQuantity"
    />

    <a
      v-if="showRemoveProp"
      class="line-item-actions__select-delete"
      @click="changeQuantity(0)"
    >
      x
    </a>
  </div>
</template>

<script>
import ChoosableGiftBtn from './choosable-gift-btn/ChoosableGiftBtn'
import SelectableLineItemQuantity from './selectable-line-item-quantity/SelectableLineItemQuantity'

export default {
  name: 'LineItemActions',
  components: {
    ChoosableGiftBtn,
    SelectableLineItemQuantity,
  },
  props: {
    lineItemQuantityProp: {
      type: Number,
      required: true,
    },
    currentVariantIdProp: {
      type: Number,
      required: true,
    },
    lineItemIdProp: {
      type: Number,
      required: true,
    },
    choosableGiftProp: {
      type: Boolean,
      default: false,
    },
    giftOptionsProp: {
      type: Boolean,
      default: false,
    },
    kitProp: {
      type: Boolean,
      default: false,
    },
    giftProp: {
      type: Boolean,
      default: false,
    },
    promotionEventStockProp: {
      type: [Number, String],
      default: null,
    },
    showActionsProp: {
      type: Boolean,
      default: true,
    },
    showSelectQuantityProp: {
      type: Boolean,
      default: true,
    },
    showRemoveProp: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      changingQuantity: false,
    }
  },
  methods: {
    newVariant(newVariant) {
      this.$emit('newVariant', newVariant)
    },
    changeQuantity(e) {
      this.$store.dispatch?.('analytics/emitGtagEvent', {
        name: 'change_item_qnt',
      })
      const newQuantity =
        typeof e === 'number'
          ? e
          : Number(e?.target?.options[e?.target?.selectedIndex]?.value || 0)
      this.$emit('updateQuantity', newQuantity)
    },
  },
}
</script>

<style lang="scss">
.choosable-gift__container {
  display: inline-block;
}

.line-item-actions {
  display: flex;
  flex-direction: row;
  align-items: center;

  .line-item-actions__select-delete {
    color: #b6b6ba;
  }

  @media (min-width: $v4_desktop) {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .line-item-actions__remove-icon {
    width: 17px;
    cursor: pointer;
  }

  .line-item-actions__select {
    position: relative;

    &::before,
    &::after {
      background-color: #d6d6da;
      content: '';
      display: block;
      position: absolute;
      width: 1px;
      height: 7px;
      right: 16px;
      top: 50%;
      margin-top: -4px;
      transition: transform 0.25s ease-in-out;
    }
    &::before {
      transform: translate3d(2px, 0, 0) rotate(45deg);
    }
    &::after {
      transform: translate3d(-2px, 0, 0) rotate(-45deg);
    }

    @media (max-width: $v4_desktop) {
      margin-top: 2 * $v4_gutter;
    }

    .line-item-actions__select-qty {
      width: 64px;
      height: 36px;
      border-radius: 4px;
      padding: 0 13px 0;
      border: 1px solid #eee;
      box-sizing: border-box;
      color: $v4_color_text;
      text-indent: 5px;
      line-height: inherit;
      cursor: pointer;
      outline: 0;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;

      @media (max-width: $v4_desktop) {
        padding-left: 5px;
        padding-right: 5px;
        margin-left: 0;
      }
    }
  }

  .line-item-actions__select-delete {
    text-decoration: none;
    font-size: 21px;
    margin-left: 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 2px 12px;

    @media (max-width: $screen_large) {
      position: absolute;
      top: 0;
      right: 0;
      height: auto;
    }
  }
}
</style>
